import { Check } from "modules/HoldingAppointmentDetails/components/Checks/components/Check";

import type { SectionMenu } from "components";
import type { Appointment } from "models";
import type { OrderedGroupedCheck } from "modules/AppointmentDetails/hooks";

type ChecksProp = {
  sectionMenu: SectionMenu;
  isExpanded: boolean;
  appointment: Appointment;
  checks?: OrderedGroupedCheck[];
};

export const Checks = ({ sectionMenu, isExpanded, appointment, checks }: ChecksProp) => {
  return checks?.map((check, index) => (
    <Check sectionMenuId={index === 0 ? sectionMenu.id : ""} key={check.id} icon={sectionMenu.icon} isExpanded={isExpanded} check={check} appointment={appointment} />
  ));
};
